export default class GalleryAlbum {
    static fromData(data) {
        if (!data) {
            return;
        }

        const album = new GalleryAlbum();
        album.id = data.id;
        album.title = data.title;
        album.description = data.description;
        album.groups = data.groups || [];
        album.creator = data.creator;
        album.createdAt = data.createdAt;
        album.mediaCount = data.mediaCount;
        album.coverImage = data.coverImage;
        album.hasWriteAccess = data.hasWriteAccess;
        album.hasUploadAccess = data.hasUploadAccess;
        album.clearing = data.clearing;
        album.translations = data.translations;
        album.mediaItems = data.mediaItems || [];

        return album;
    }
}
